export const theme = {
  palette: {
    background: "#f3f3f5",
    bg: "#F4F7F9",
    bgBlue: "#D8EFFF",
    main: "#337DD3",
    divider: "#BFBFBF",
    gray: "#7D7D7D",
    gray2: "#828282",
    accent: "#F39800",
    alert: "#E05853",
    text: "#2D3748",
    lemon: "#D7F300",
    primary: "#4f7fcd",
    white: "#ffffff",
    shadowGrey: "rgba(0, 0, 0, 0.15)",
  },
} as const;
